import { useQuery } from "@apollo/client/react";
import { NotificationUnreadCountDocument } from "#app/lib/data";

/**
 * Reads the notification unread count directly from Apollo cache.
 * Isolated from AppDataContext so count changes only re-render consumers
 * of this hook — not the entire app tree.
 */
export function useInboxUnreadCount(): number {
  const { data } = useQuery(NotificationUnreadCountDocument, {
    fetchPolicy: "cache-only",
  });
  return data?.notificationUnreadCount ?? 0;
}
